var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-8 px-6",attrs:{"fluid":""}},[_c('PageTitle',{attrs:{"icon":"mdi-pencil-box-outline","main":"Compras e licitações","sub":"contratos","home":"/compras"}}),_c('div',[_c('Contrato')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }